<template>
  <validation-observer v-slot="{ invalid }">
    <h5>Supplier: <br>{{ supplier }}</h5>

    <form @submit.prevent="handleSubmit">
      <hr />

      <validation-provider name="Code Batch Name" v-slot="context" rules="required">
        <b-form-group label="Code Batch Name">
          <b-form-input
            v-model="title"
            placeholder="e.g Lorem Ipsum"
            :state="getValidationState(context)"
            v-bind="context.ariaInput"
          />

          <b-form-invalid-feedback v-bind="context.ariaMsg">
            {{ context.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <hr />

      <b-row>
        <b-col>
          <validation-provider name="End Time" v-slot="context" rules="required">
            <b-form-group label="End Time">
              <b-form-datepicker
                locale="nb-NO"
                :start-weekday="1"
                v-model="end_time"
                :state="getValidationState(context)"
                v-bind="context.ariaInput"
              />

              <b-form-invalid-feedback v-bind="context.ariaMsg">
                {{ context.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col>
          <validation-provider name="Alert When" v-slot="context" rules="required">
            <b-form-group label="Alert When (Remaining Codes)">
              <b-form-input
                v-model="alert_when"
                placeholder="e.g 1"
                :state="getValidationState(context)"
                v-bind="context.ariaInput"
              />

              <b-form-invalid-feedback v-bind="context.ariaMsg">
                {{ context.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>

      <validation-provider name="Codes" v-slot="context" rules="required">
        <b-form-group label="Codes">
          <b-textarea
            rows="10"
            v-model="codes"
            placeholder="e.g A 1212121212"
            :state="getValidationState(context)"
            v-bind="context.ariaInput"
          />

          <b-form-invalid-feedback v-bind="context.ariaMsg">
            {{ context.errors[0] }}
          </b-form-invalid-feedback>
        </b-form-group>
      </validation-provider>

      <b-row v-if="!batch.item.deleted_at" align-h="end">
        <b-col cols="auto">
          <b-button type="submit" variant="primary" :disabled="$cannot('supplier.manage') || invalid"> Update </b-button>
        </b-col>
      </b-row>
    </form>
  </validation-observer>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { getValidationState } from '../page-helpers'
import { products } from '@/api'

export default {
  name: 'CSVCodesBatchEditForm',
  props: {batch: {type: Object}},
  inject: ['$cannot'],
  components: {},

  data() {
    return {
      suppliers: [],
      supplier: this.batch.item.supplier,

      codes: this.batch.item.raw_codes,
      alert_when: this.batch.item.alert_when,
      end_time: this.batch.item.end_time,
      title: this.batch.item.title,
    }
  },

  methods: {
    getValidationState,

    async handleSubmit() {
      await this.$store.dispatch('auth/refreshToken');
      await products.variations.batches.update(this.batch.item.id,
        {
          codes: this.codes,
          alert_when: this.alert_when,
          end_time: this.end_time,
          title: this.title,
        }
      )

      this.$bvToast.toast(`Batch updated.`, {
        title: 'Batch updated',
        variant: 'primary',
      })

      this.$emit('close')
    },
  },
}
</script>
